// Config do fundo dithered na identidade StationZero: warp config de
// https://shaders.paper.design/dithering, violeta com o mesmo grão de 4px e
// alpha suave do antigo efeito canvas feito à mão. Compartilhada entre o
// componente React (telas de auth) e o entrypoint vanilla (páginas
// server-rendered: landing, waitlist, pending access).
export const DITHER_BACKGROUND = {
  colorBack: '#00000000',
  colorFront: '#a78bfa50',
  shape: 'warp',
  type: '4x4',
  fit: 'contain',
  scale: 1,
  size: 4,
  speed: 0.15,
} as const;
